'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.directives.finishRender', []).directive('tbOnFinishRender', OnFinishRender).name;

/*@ngInject*/

function OnFinishRender($timeout) {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit(attr.tbOnFinishRender);
                });
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/components/finish-render.directive.js